import * as z from 'zod'

import { HOUSEHOLD_STEPS } from '@flows/configs/householdAt/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_HouseholdV1GetsafeAt } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  return (
    schemaUtils.bornOnErrorMap(issue, {
      min: 'sharedFlows_householdAt:steps.born_on.errors.tooYoung',
      max: 'sharedFlows_householdAt:steps.born_on.errors.tooOld',
    }) ?? { message: ctx.defaultError }
  )
}

const household_at_born_on = (params: StepConfigParams) =>
  ({
    schema: z.object({
      born_on: BaseSchema_HouseholdV1GetsafeAt.shape.born_on,
    }),
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.born_on.title',
        },
      },
      {
        type: 'date',
        shouldTrackValues: true,
        name: 'born_on',
        disabledIfValueExists: true,
      },
    ],
    subFlow: params.subFlow,
    nextStep: HOUSEHOLD_STEPS.household_at_quote,
  }) as const satisfies AnyStepConfiguration

export default household_at_born_on
